export default class LinkData {
    constructor(name, address, icon, heading, tags) {
        this.name = name;
        this.address = address;
        this.icon = icon;
        this.heading = heading,
        this.tags = tags;
    }
}